if (!customElements.get('bundle-add-to-cart')) {
  class BundleAddToCart extends HTMLElement {
    constructor() {
      super()

      this.button = this.querySelector('button');
      this.erroMessageField = document.querySelector('bundle-products [data-error-message]');
      this.discountType = this.dataset.discountType;
      this.discountAmount = this.dataset.discountAmount;
      this.includeParentProduct = this.dataset.includeParentProduct;
    }

    connectedCallback() {
      this.attachEvents()

      document.addEventListener('dcb:bundle-is-valid', this.generateItems.bind(this));
    }

    attachEvents() {
      this.button.addEventListener('click', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent('dcb:submit-bundle'));
    }

    generateItems(event) {
      const bundleId = Date.now();
      const quantity = Number(document.querySelector('.product quantity-input input')?.value) || 1;
      let items = [];
      let mainProduct = {};
      let mainProductTitle = event.detail.mainProductTitle;
      let mainProductUrl = event.detail.mainProductUrl;

      mainProduct.id = event.detail.mainProductId;
      mainProduct.quantity = quantity;

      mainProduct.properties = {};
      mainProduct.properties._bundleId = bundleId;
      mainProduct.properties._bundleParent = 'true';

      if (this.discountType) {
        mainProduct.properties._bundleDiscountType = this.discountType;
      }

      if (this.discountAmount) {
        mainProduct.properties._bundleDiscountAmount = this.discountAmount;
      }

      event.detail.variants.forEach(variant => {
        const hasVariant = items.find(item => item.id === variant.value);

        if (hasVariant) {
          hasVariant.quantity += quantity;

          return;
        }

        let item = {};

        item.properties = {};

        item.id = variant.value;
        item.quantity = quantity;
        item.properties._bundleId = bundleId;
        item.properties._bundleTitle = mainProductTitle;
        item.properties._bundleUrl = mainProductUrl;
        item.properties._bundleItem = 'true';
        if (this.includeParentProduct) {
          item.properties._bundleChild = 'true';
        }

        items.push(item);
      });

      if (this.includeParentProduct) {
        items.push(mainProduct);
      }

      if (this.hasAttribute("data-warm-weather-shipping")) {
        items.push({
          id: this.getAttribute("data-warm-weather-shipping"),
          quantity: 1,
          properties: { _isWarmWeatherShippingProduct: true }
        });
      }

      if (this.hasAttribute('data-coolers') && this.dataset.coolers.trim() != '') {
        const coolers = this.dataset.coolers.trim().split(',');
        coolers.forEach(cooler => items.push({ id: cooler, quantity }))
      }

      this.addToCart(items);
    }

    async addToCart(items) {
      this.button.setAttribute('aria-disabled', true);
      this.button.classList.add('loading');
      this.button.querySelector('span').classList.add('hidden');
      this.button.querySelector('.loading-overlay__spinner').classList.remove(
        'hidden',
      );

      await window.theme
        .addToCart(items)
        .then((result) => {
          if (result.error) {
            this.handleErrorMessage(result.error);
            return;
          }
          this.error = false;
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.querySelector('span').classList.remove('hidden');
          this.button.removeAttribute('aria-disabled');
          this.button.querySelector('.loading-overlay__spinner').classList.add('hidden');

          document.dispatchEvent(new CustomEvent("cart:update"));
        });
    }

    handleErrorMessage(message = '') {
      if (message === '') {
        this.erroMessageField.classList.add('hidden');

        return;
      }

      this.erroMessageField.textContent = message;

      this.erroMessageField.classList.remove('hidden');
    }
  }

  customElements.define('bundle-add-to-cart', BundleAddToCart)
}
